// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-workbook-dialog__import-cancel-dialog {
  width: 480px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CreateWorkbookDialog/CreateWorkbookDialog.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR","sourcesContent":[".create-workbook-dialog__import-cancel-dialog {\n  width: 480px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
